


































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { INFORMATION_BOX_TYPE, type InformationBoxType } from '~/components/atoms/InformationBox/InformationBoxType';

export default defineComponent({
  name: 'InformationBox',
  props: {
    type: {
      type: String as PropType<InformationBoxType>,
      default: INFORMATION_BOX_TYPE.INFO,
    },
  },
  setup(props) {
    const backgroundColor = computed(() => {
      return {
        [INFORMATION_BOX_TYPE.INFO]: 'bg-EXPONDO-secondary-light',
        [INFORMATION_BOX_TYPE.WARNING]: 'bg-EXPONDO-yellow-light',
        [INFORMATION_BOX_TYPE.NEUTRAL]: 'bg-EXPONDO-secondary-light',
        [INFORMATION_BOX_TYPE.SUCCESS]: 'bg-EXPONDO-green-light',
      }[props.type];
    });

    const borderColor = computed(() => {
      return {
        [INFORMATION_BOX_TYPE.INFO]: 'border-EXPONDO-primary-80',
        [INFORMATION_BOX_TYPE.WARNING]: 'border-EXPONDO-gold',
        [INFORMATION_BOX_TYPE.NEUTRAL]: 'border-EXPONDO-grey-20',
        [INFORMATION_BOX_TYPE.SUCCESS]: 'border-EXPONDO-grey-20',
      }[props.type];
    });

    const iconColor = computed(() => {
      return {
        [INFORMATION_BOX_TYPE.INFO]: 'text-EXPONDO-primary',
        [INFORMATION_BOX_TYPE.WARNING]: 'text-EXPONDO-gold',
        [INFORMATION_BOX_TYPE.NEUTRAL]: 'text-EXPONDO-black',
        [INFORMATION_BOX_TYPE.SUCCESS]: 'text-EXPONDO-black',
      }[props.type];
    });

    return {
      backgroundColor,
      borderColor,
      iconColor,
    };
  },
});
